/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type StreamListItem_stream$ref: FragmentReference;
export type StreamListItem_stream = {|
  +id: string,
  +title: ?string,
  +state: ?string,
  +availableAt: ?string,
  +$refType: StreamListItem_stream$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "StreamListItem_stream",
  "type": "Stream",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "state",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "availableAt",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'a3e65d79c47b572ed9c567fe557db729';
module.exports = node;



// WEBPACK FOOTER //
// src/components/streams/__generated__/StreamListItem_stream.graphql.js